module.exports = __webpack_public_path__ + "static/valentin-fd727b26df32b3b3aa6e1c2e1c360c3c.jpg";